export const data = [
  {
    id: '01',
    question: 'Popular_question_1_',
    answer: 'Popular_answer_1_',
  },
  {
    id: '02',
    question: 'Popular_question_2_',
    answer: 'Popular_answer_2_',
  },
  {
    id: '03',
    question: 'Popular_question_3_',
    answer: 'Popular_answer_3_',
  },
  {
    id: '04',
    question: 'Popular_question_4_',
    answer: 'Popular_answer_4_',
  },
  {
    id: '05',
    question: 'Popular_question_5_',
    answer: 'Popular_answer_5_',
  },
  {
    id: '06',
    question: 'Popular_question_6_',
    answer: 'Popular_answer_6_',
  },
];
